'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const HoursBarChartInner = dynamic(() => import('./HoursBarChartInner'), { ssr: false });

export default function HoursBarChart() {
  return (
    <div className="card-elevated p-5 h-full">
      <div className="mb-4">
        <h3 className="text-[15px] font-600 text-foreground">Hours per Staff Member</h3>
        <p className="text-xs text-muted-foreground mt-0.5">Current pay period — top 10 by total hours</p>
      </div>
      <HoursBarChartInner />
      <div className="flex items-center gap-4 mt-3">
        {[
          { label: 'Regular', color: 'bg-primary' },
          { label: 'Overtime', color: 'bg-warning' },
        ]?.map((item) => (
          <div key={`leg-${item?.label}`} className="flex items-center gap-1.5">
            <span className={`w-2.5 h-2.5 rounded-sm ${item?.color}`} />
            <span className="text-[11px] text-muted-foreground">{item?.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}